/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvoiceStatus } from './InvoiceStatus';
import {
    InvoiceStatusFromJSON,
    InvoiceStatusFromJSONTyped,
    InvoiceStatusToJSON,
} from './InvoiceStatus';

/**
 * 
 * @export
 * @interface GetFacilityInvoiceStatuses200Response
 */
export interface GetFacilityInvoiceStatuses200Response {
    /**
     * 
     * @type {Array<InvoiceStatus>}
     * @memberof GetFacilityInvoiceStatuses200Response
     */
    data?: Array<InvoiceStatus>;
}

/**
 * Check if a given object implements the GetFacilityInvoiceStatuses200Response interface.
 */
export function instanceOfGetFacilityInvoiceStatuses200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetFacilityInvoiceStatuses200ResponseFromJSON(json: any): GetFacilityInvoiceStatuses200Response {
    return GetFacilityInvoiceStatuses200ResponseFromJSONTyped(json, false);
}

export function GetFacilityInvoiceStatuses200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFacilityInvoiceStatuses200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(InvoiceStatusFromJSON)),
    };
}

export function GetFacilityInvoiceStatuses200ResponseToJSON(value?: GetFacilityInvoiceStatuses200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(InvoiceStatusToJSON)),
    };
}

